import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ContactUsComponent from '@/components/ContactUsComponent.vue';
    import IntroComponent from '@/components/IntroComponent.vue';
    import ProjectsComponent from '@/components/ProjectsComponent.vue';
    import { ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

    const skillsRef = ref();
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(IntroComponent, {
      onScrollToSkills: _cache[0] || (_cache[0] = ($event: any) => (skillsRef.value.$el.scrollIntoView({ behavior: 'smooth' })))
    }),
    _createVNode(ProjectsComponent, {
      ref_key: "skillsRef",
      ref: skillsRef
    }, null, 512),
    _createVNode(ContactUsComponent)
  ]))
}
}

})